import React from "react";
import { useTranslation } from "react-i18next";
import feature1 from "../../assets/img/features-4.jpg";
import feature2 from "../../assets/img/features-2.png";
import feature3 from "../../assets/img/features-1.jpg";
import feature4 from "../../assets/img/features-3.png";

const imageMap = [feature1, feature2, feature3, feature4];

const Features = () => {
  const { t } = useTranslation();
  const features = t("features2.items", { returnObjects: true });

  return (
    <section id="features" className="features section">
      <div className="container section-title" data-aos="fade-up">
        <h2>{t("features2.title")}</h2>
        <p>{t("features2.description")}</p>
      </div>
      <div className="container">
        {features.map((f, i) => (
          <div
            key={i}
            className={`row gy-4 align-items-center features-item shadow-lg rounded-4 p-4 mb-5 bg-white`}
          >
            <div
              className={`col-md-5 d-flex align-items-center ${
                i % 2 === 1 ? "order-1 order-md-2" : ""
              }`}
              data-aos="zoom-out"
              data-aos-delay={100 * (i + 1)}
            >
              <img
                src={imageMap[i]}
                className="img-fluid rounded-3"
                alt="Feature"
              />
            </div>
            <div
              className={`col-md-7 ${i % 2 === 1 ? "order-2 order-md-1" : ""}`}
              data-aos="fade-up"
              data-aos-delay={100 * (i + 1)}
            >
              <h3 className="mb-3 my-features-title fw-bold">{f.title}</h3>
              {f.italic && (
                <p className="fst-italic text-muted mb-3">{f.italic}</p>
              )}
              {f.content && <p className="mb-3">{f.content}</p>}
              {f.list && (
                <ul className="list-unstyled ps-0">
                  {f.list.map((item, idx) => (
                    <li key={idx} className="mb-2 d-flex align-items-start">
                      <i className="bi bi-check2-circle me-2 text-success"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
